// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"82e5c232","422":"fe79d2cc","785":"344d2492","787":"e808bbcc"}[chunkId] + ".chunk.js";
};